import '../globals';
import {Modal} from 'bootstrap';


(function ($) {
    jQuery.fn.ajaxSubmit = function (options) {
        var $this = $(this);

        var defaults = {
            targetCallback: function ($form, $target) {
                var $overlay = $('<div class="loading-overlay" style="position:absolute; top:0; bottom:0; left:0; right:0;z-index: 9999; background-color: black; opacity:0.5; text-align:center"></div>');
                var loadingGif = $this.data('loading-circle');
                $overlay.append('<img width="32" height="32" style="top: 50%;position: relative;transform: translateY(-50%);" src="' + loadingGif + '">');
                $target.find('.modal-dialog').append($overlay);
                $target.on('hidden.bs.modal', function () {
                    $overlay.remove();
                });
            },
            formCallback: function (response, statusCode, $realForm, $target) {
                const event = new Event('plandent.ajaxSubmit.submit')
                $($realForm)[0].dispatchEvent(event);
                $('.loading-overlay').remove();
                $realForm.prepend(response.responseText);
                $target.append('<button data-bs-dismiss="modal" class="d-none" id="modal-ajax-submit-dismiss" aria-hidden="true"></button>');
                $('#modal-ajax-submit-dismiss').click();

                const modal = Modal.getOrCreateInstance($target);
                modal.hide();
            }
        };

        //get Settings from Data attributes
        var data = $this.data();
        if (data !== null && data !== undefined) {
            Object.keys(data).forEach(function (key) {
                var newKey = key.replace(/ajaxSubmit/, '');
                if (newKey !== key) {
                    newKey = newKey.charAt(0).toLowerCase() + newKey.slice(1);
                    data[newKey] = data[key];
                }
                delete data[key];
            });
        }
        var opts = $.extend({}, defaults, options, data);
        var $form = $(opts.form);
        var $target = $(opts.target);
        var formCallback = opts.formCallback;
        var targetCallback = opts.targetCallback;
        var $realForm = $form.filter('form');

        $this.on('click', function () {
            var data = $form.serializeArray();
            var url = $realForm.prop('action');
            var method = $realForm.prop('method');
            targetCallback($realForm, $target);
            $.ajax({
                url: url,
                method: method,
                data: data,
                complete: function (response, statusCode) {
                    return formCallback(response, statusCode, $realForm, $target)
                }
            })
        })

    }
})(jQuery);
$('.ajax-submit').ajaxSubmit();
